import React from "react";
import { useChat } from "../../context/ChatContext";
import FloatingChatBox from "./FloatingChatBox";

const FloatingChatContainer = () => {
  const { openChats, closeChat, toggleCollapse, getUnreadCount } = useChat();

  if (!openChats || openChats.length === 0) {
    return null;
  }

  return (
    <div
      className="fixed bottom-0 right-2 sm:right-6 z-[9999] flex items-end gap-3 pointer-events-none"
      aria-label="Active chat conversations"
    >
      {openChats.map((chat) => (
        <FloatingChatBox
          key={chat.proposalId}
          chat={chat}
          onClose={() => closeChat(chat.proposalId)}
          onToggleCollapse={(forceState) => toggleCollapse(chat.proposalId, forceState)}
          unreadCount={getUnreadCount(chat.proposalId)}
          isProfessionalView={chat.isProfessionalView}
        />
      ))}
    </div>
  );
};

export default FloatingChatContainer;

